"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolTipReact = exports.ToolTip = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _store = require("../../store");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ToolTipReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ToolTipReact, _React$Component);
  var _super = _createSuper(ToolTipReact);
  function ToolTipReact() {
    (0, _classCallCheck2.default)(this, ToolTipReact);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(ToolTipReact, [{
    key: "showToolTip",
    value: function showToolTip(event) {
      event.target.nextSibling.classList.add('in');
    }
  }, {
    key: "hideToolTip",
    value: function hideToolTip(event) {
      event.target.nextSibling.classList.remove('in');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        message = _this$props.message,
        field = _this$props.field,
        placeholder = _this$props.placeholder,
        id = _this$props.id;
      var popupClassName = "".concat(className, "-popover");
      var fieldTag = field === 'button' ? /*#__PURE__*/_react.default.createElement("button", {
        onFocus: this.showToolTip,
        onBlur: this.hideToolTip,
        onMouseEnter: this.showToolTip,
        onMouseLeave: this.hideToolTip
      }, "Search") : field === 'input' ? /*#__PURE__*/_react.default.createElement("input", {
        id: id,
        onFocus: this.showToolTip,
        onBlur: this.hideToolTip,
        onMouseEnter: this.showToolTip,
        onMouseLeave: this.hideToolTip,
        type: "text",
        readOnly: true,
        placeholder: placeholder,
        className: className
      }) : '';
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, fieldTag, /*#__PURE__*/_react.default.createElement("div", {
        className: "popover right visible-sm",
        role: "tooltip",
        "data-popover-id": popupClassName
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "popover-content"
      }, message)));
    }
  }]);
  return ToolTipReact;
}(_react.default.Component);
exports.ToolTipReact = ToolTipReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    siteInfo: state.siteInfo
  };
};
ToolTipReact.propTypes = {
  className: _propTypes.default.string.isRequired,
  siteInfo: _propTypes.default.object,
  field: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  message: _propTypes.default.string.isRequired,
  id: _propTypes.default.string
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var ToolTip = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ToolTipReact);
exports.ToolTip = ToolTip;
